<mat-tab-group [(selectedIndex)]="selectedTabIndex" mat-stretch-tabs="false">
  <mat-tab label="Globale Kannbeschreibungen">
    @if (selectedTabIndex === 0) {
      <app-can-do-statement-panel [flavor]="'global'" [entryId]="globalEntryId"
                                  [categoryId]="globalCategoryId" [initialQuery]="initialSearchQuery"></app-can-do-statement-panel>
    }
  </mat-tab>
  <mat-tab label="Detaillierte Kannbeschreibungen">
    @if (selectedTabIndex === 1) {
      <app-can-do-statement-panel [flavor]="'detailed'" [entryId]="detailedEntryId"
                                  [categoryId]="detailedCategoryId" [initialQuery]="initialSearchQuery"></app-can-do-statement-panel>
    }
  </mat-tab>
</mat-tab-group>
